<template>
  <div class="sidebar-container">
    <el-menu
      class="menu-vertical"
      :default-active="activeMenu"
      background-color="#FBFBF7"
      active-text-color="#c39143"
      text-color="#606266"
      :collapse="isCollapse"
      width="280px">
      <div class="side-top-logo">
        <!-- TODO: 画像の差し替え。#106 -->
        <img v-if="!isCollapse" class="horizontal-logo" src="~/assets/logo_horizontal.svg">
        <img v-if="isCollapse" class="only-image-logo" src="~/assets/logo_only_image.svg">
      </div>
      <el-menu-item index="1" @click="$router.push('/')">
        <el-icon><HomeFilled /></el-icon>
        <span>ホーム</span>
      </el-menu-item>
      <el-menu-item index="2" @click="$router.push('/nursery/shift_managements')">
        <el-icon><Grid /></el-icon>
        <span>シフト表</span>
      </el-menu-item>
      <el-menu-item index="3" @click="$router.push('/nursery/works')">
        <el-icon><Clock /></el-icon>
        <span>出退勤記録確認・編集</span>
      </el-menu-item>
      <el-menu-item index="3-timer" @click="confirmExitVisible = true">
        <el-icon><Timer /></el-icon>
        <span>打刻画面</span>
      </el-menu-item>
      <el-menu-item index="4" @click="$router.push('/nursery/settings')">
        <el-icon><Setting /></el-icon>
        <span>設定</span>
      </el-menu-item>
      <el-sub-menu index="5">
        <template #title>
          <el-icon><ChatLineRound /></el-icon>
          <span>サポート</span>
        </template>
        <el-menu-item index="5-1" @click="$router.push('/nursery/support')">
          <el-icon><QuestionFilled /></el-icon>
          <span>よくある質問</span>
        </el-menu-item>
        <el-menu-item index="5-2" @click="openManualLink()">
          <el-icon><Notebook /></el-icon>
          <span>マニュアル</span>
        </el-menu-item>
      </el-sub-menu>
    </el-menu>
    <elw-dialog>
      <el-dialog
        v-model="confirmExitVisible"
        :close-on-press-escape="false">
        <template #header>
          <span class="el-dialog__title">
            <span class="dialog-title">
              <img src="~/assets/error.svg">
              打刻画面に遷移しようとしています
            </span>
          </span>
        </template>
        <p>打刻画面からシフト管理画面に戻る場合、再ログインが必要になります。よろしいですか？</p>
        <div class="dialog-footer">
          <cs-button type="info" button-type="negative" @click="confirmExitVisible = false">
            <template #icon>
              <img src="~/assets/icons/close_negative.svg" width="20" height="20">
            </template>
            キャンセル
          </cs-button>
          <cs-button type="primary" @click="$router.push('/guest_login')">
            <template #icon>
              <img src="~/assets/icons/confirm_primary.png">
            </template>
            移動する
          </cs-button>
        </div>
      </el-dialog>
    </elw-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRoute, useNuxtApp } from '#app'
import { apiWebNurseryMePath } from '../rails/routes'
import CsButton from '~/components/CsButton.vue'
import ElwDialog from '~/components/ElwDialog.vue'
import { HomeFilled, Grid, Clock, Timer, Setting, ChatLineRound, QuestionFilled, Notebook } from '@element-plus/icons-vue'

const props = defineProps<{
  isCollapse?: boolean
}>()

const route = useRoute()
const { $axios } = useNuxtApp() as any

const userType = ref('')
const confirmExitVisible = ref(false)

const activeMenu = computed<string>(() => {
  const path = route.path
  if (/^\/nursery\/settings/.test(path)) {
    return '4'
  }
  if (/^\/nursery\/shift_managements/.test(path)) {
    return '2'
  }
  if (/^\/nursery\/works/.test(path)) {
    return '3'
  }
  if (/^\/nursery\/support/.test(path)) {
    return '5-1'
  }
  return '1'
})

const openManualLink = (): void => {
  window.open('https://room.lookmee.jp/view/knowledgebase/766', '_blank')
}

onMounted(async () => {
  try {
    const me = await $axios.$get(apiWebNurseryMePath()) as {
      id: number;
      userTitle: string;
      nurseryId: number;
      name: string;
      isBeta: boolean;
      isReferenceRequired: boolean;
      userType: string;
      permissions: string[];
    }
    userType.value = me.userType
  } catch (e) {
    console.error('Failed to fetch user info in sidebar:', e)
  }
})
</script>

<style lang="sass" scoped>
.menu-vertical
  height: 100%
  min-height: calc(100vh - 50px) /* ヘッダー分の50pxを強制的に減らしている */
  max-height: calc(100% - 0px)
  font-weight: bold
.menu-vertical:not(.el-menu--collapse)
  width: 240px
:deep(.el-menu-item)
  font-size: 18px
:deep(.el-sub-menu .el-sub-menu__title)
  font-size: 18px
:deep(.el-menu-item .el-icon)
  font-size: 22px
  margin-right: 4px
:deep(.el-sub-menu .el-icon)
  font-size: 22px
  margin-right: 8px
.side-top-logo .horizontal-logo
  padding: 0.5rem 0.3rem
  height: 76px
.side-top-logo .only-image-logo
  padding: 0.5rem 0.3rem
  height: 76px

.dialog-footer
  margin-top: 50px
  display: flex
  justify-content: flex-end
  .cs-button
    margin-left: 20px

.dialog-title
  img
    width: 32px
    height: 32px
    vertical-align: middle
    margin: -6px 8px 0 0
</style>
